import { Stack, useTheme } from "@mui/material";
import { Button, CloseIcon } from "components";
import { ConfirmationModal } from "components/modal/ConfirmationModal";
import React from "react";
import { useNavigate } from "react-router-dom";
import { KbFileDetailResponse } from "shared";
import { ActionButtonType } from "../types";

export const KbDiscardButton = ({
  kbFileDetails,
  mode,
  tabValue,
  onActionButtonClick,
  isDrawer,
}: {
  kbFileDetails: KbFileDetailResponse;
  mode: "edit" | "view";
  tabValue?: number;
  onActionButtonClick: (type: ActionButtonType) => void;
  isDrawer?: boolean;
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const handleDiscard = (e: React.MouseEvent) => {
    if (mode === "view") {
      if (!isDrawer) {
        navigate(`/app/kb/folder/${kbFileDetails.parent_id}`);
      }
    } else {
      setIsModalOpen(true);
    }
    e.stopPropagation();
  };

  return (
    <>
      <Stack
        // component={"button"}
        onClick={handleDiscard}
        sx={{
          width: "40px",
          height: "40px",
          borderRadius: "100%",
          boxShadow: "0px 0px 4px 0px #00000029,0px 0px 2px 0px #00000014",
          border: `1px solid ${theme.palette.neutral["010"]}`,
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "#FFF",
          cursor: "pointer",
        }}
      >
        <CloseIcon />
      </Stack>
      {isModalOpen && (
        <ConfirmationModal
          paperStyles={{
            width: "524px",
          }}
          open={isModalOpen}
          title="Unsaved Changes"
          tagline="You have changes that haven’t been saved yet."
          primaryButtonText="Keep editing"
          secondaryButtonText="Save as draft"
          footer={
            <Stack
              direction="row"
              mt="24px"
              gap="16px"
              justifyContent="flex-end"
            >
              {kbFileDetails?.versions &&
                kbFileDetails?.versions.length === 1 &&
                kbFileDetails?.versions[0].record_visibility === "unsaved" && (
                  <Button
                    disabled={false}
                    variant="secondary"
                    onClick={() => onActionButtonClick("discard")}
                    sx={{ mr: "auto" }}
                  >
                    Discard
                  </Button>
                )}

              <Button
                disabled={false}
                variant="secondary"
                onClick={() => {
                  onActionButtonClick("save_exit");
                  if (!isDrawer) {
                    navigate(`/app/kb/folder/${kbFileDetails.parent_id}`);
                  }
                }}
              >
                Save as draft
              </Button>

              <Button variant="primary" onClick={() => setIsModalOpen(false)}>
                Keep editing
              </Button>
            </Stack>
          }
        />
      )}
    </>
  );
};
